import React from "react";
import styles from "../styles/AIChatAssistantCard.module.css";

export default function AIChatAssistantCard() {
  return (
    <div className={styles['feature-card']}>
      <div className={styles['feature-image']}>
        <img src="/background4.svg" />
      </div>
      <div className={styles['feature-content']}>
        <div className={styles['feature-content1']}>
          <h3>AI Chat Assistant</h3>
          <p>Get instant help from our AI Assistant — from PNR checks to smart route suggestions, all via AI assistant or WhatsApp Bot.</p>
        </div>
      </div>
    </div>
  );
}